import clsx from 'clsx'
import { useEffect, useState } from 'react'

const CommonCell =({params, type})=> {

  const [subtitle, setSubTitle] = useState(params.subtitle);
  const [text, setText] = useState(params.text);

  useEffect(()=> {

    switch(type){
      case 'blog':
        if(params.specials && params.specials.nodes && params.specials.nodes[0]) setSubTitle(params.specials.nodes[0].name);
        break;

      case 'tv':
        const {content} = params;
        setText(content);
        break;
    }

  }, [])


  return (
    <div className="event_item_info">
      <p className="title date_wrapper">
        {subtitle && <span className={clsx("type text-lg", type)}>{subtitle}</span>}
        {params.time && <span className={clsx("type text-lg", type)}>{params.time}</span>}
        {params.type && <span className={clsx("type", params.type)}>{params.type}</span>}
        {params.title}
      </p>
      {type === "tv" && <p dangerouslySetInnerHTML={{ __html: text  }} />}
      {params.isKPOP && <a href="/kpop"><img className="logo_kpop" src="/images/common/logo_kpop.png" alt=""/></a>}
    </div>
  )
}

export default CommonCell
